export default "__VITE_PUBLIC_ASSET__d318b617__"